import React, { Component } from 'react';
import { Platform, StyleSheet } from 'react-native';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { clearEventDetails, setEditingEvent } from './actions';
import { openCaseInfo, resetState as resetCaseState } from '../cases/actions';
import { getEditingCase } from '../cases/selector';
import { isSuperAdmin } from '../userProfile/selector';
import { uiFormattedEditingEvent, getEventNotes } from './selector';
import { getMilitaryEmployerStatus } from '../../selectors/entities';

import {
  LABS,
  PHA,
  DRHA,
  AUDIOGRAM,
  OHE,
  IMMUNIZATION_SCHEDULER,
  IMMUNIZATION_CHECKLIST,
} from '../../constants/permissions';
import { currentEmployerPermissions, editingCasePermissions } from '../../helpers/permissions';

import { OPComponent, NavBar, Utils, I18n, Navigation } from '../components';

import EventDetailsView from './event_details';

const EDIT_EVENT_NAVBAR_ID = 'edit';

class EventDetails extends OPComponent {
  constructor(props) {
    super(props);
  }

  setUpNavButtons() {
    const editingEvent = this.props.editingEvent;
    let editable = !!this.props.editable;
    if (this.props.isMilitaryEmployer) {
      // uncomment to allow editing for super admins
      // editable = !!this.props.superAdmin;
      editable = false;
    }

    Navigation.setButtons(
      {
        rightButtons: editable ? [NavBar.buttons.edit] : [],
        leftButtons: [NavBar.buttons.done],
      },
      this.props.componentId
    );
  }

  componentDidMount() {
    Utils.trackScreen('Calendar', 'Event Details');

    this.props.actions.setEditingEvent(this.props.eventId, this.props.caseId);
    this.props.actions.openCaseInfo(this.props.caseId);

    Navigation.setButtons(
      {
        leftButtons: [NavBar.buttons.done],
      },
      this.props.componentId
    );

    Navigation.registerForButtonEvents(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.editingEvent && !prevProps.editingEvent) {
      this.setUpNavButtons();
    }
  }

  componentWillUnmount() {
    this.props.actions.clearEventDetails();
    this.props.actions.resetCaseState();
    Navigation.unRegisterForButtonEvents(this);
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;

    if (NavBar.handleButtonPress(componentId, buttonId)) return;

    if (buttonId === EDIT_EVENT_NAVBAR_ID) {
      this.openEventForEdit();
    }
  };

  openEventForEdit() {
    let { instanceStart, instanceEnd } = this.props;

    Utils.trackEvent('Navigation', 'Load', 'Event Form');
    Navigation.openScreen(
      {
        screen: 'EventForm',
        title: I18n.t('calendar.editEvent'),
        passProps: {
          instanceStart,
          instanceEnd,
        },
      },
      this.props.componentId
    );
  }

  render() {
    const props = this.props;
    return (
      <EventDetailsView
        event={props.editingEvent}
        eventNotes={props.eventNotes}
        caseName={props.caseName}
        instanceStart={props.instanceStart}
        instanceEnd={props.instanceEnd}
        canViewEditingCasePatientImmunizations={props.canViewEditingCasePatientImmunizations}
        canViewPHAChecklist={props.canViewPHAChecklist}
        isMilitaryEmployer={props.isMilitaryEmployer}
      />
    );
  }
}

const styles = StyleSheet.create({});

function mapStateToProps(state, ownProps) {
  return {
    editingEvent: uiFormattedEditingEvent(state),
    canEditImmunizationsEvents: currentEmployerPermissions(IMMUNIZATION_SCHEDULER).canEdit,
    canEditDRHAEventsEmployer: currentEmployerPermissions(DRHA).canEdit,
    canEditLabsEventsEmployer: currentEmployerPermissions(LABS).canEdit,
    canEditOHEEventsEmployer: currentEmployerPermissions(OHE).canEdit,
    canEditAudiogramEventsEmployer: currentEmployerPermissions(AUDIOGRAM).canEdit,
    canEditPHAEventsEmployer: currentEmployerPermissions(PHA).canEdit,
    canViewEditingCasePatientImmunizations: editingCasePermissions(IMMUNIZATION_CHECKLIST).canView,
    canViewPHAChecklist: currentEmployerPermissions(PHA).canView,
    eventNotes: getEventNotes(state),
    caseName: getEditingCase(state)?.name || ownProps.caseName,
    isMilitaryEmployer: getMilitaryEmployerStatus(state),
    superAdmin: isSuperAdmin(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        clearEventDetails,
        setEditingEvent,
        openCaseInfo,
        resetCaseState,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDetails);
